import {createToaster} from './toasts'
import {createTransition} from './transitions'
import './transitions.css'
import './toasts.css'


import $ from 'jquery';
const VueToasts = {
  install () {
    createTransition($, window, document)
    createToaster($, window, document)
  }
}

export default VueToasts